import { memo } from "react";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";

import { AdStatus } from "../../types";

export interface EditNonPublishableAdDialogProps
  extends Omit<DialogProps, "onClose" | "onSubmit"> {
  adStatus?: AdStatus;
  onClose: () => void;
  onSubmit?: () => void;
}

const EditNonPublishableAdDialog: React.FC<EditNonPublishableAdDialogProps> = ({
  adStatus,
  onClose,
  onSubmit,
  open,
  ...props
}) => {
  const userAction =
    adStatus === "cancelled"
      ? "Denna annons har avbrutits"
      : adStatus === "sent"
        ? "Du har redan skickat in denna annons till tidningen"
        : "Denna annons går inte att redigera";

  return (
    <Dialog open={open} onClose={onClose} {...props}>
      <Box
        component="article"
        sx={{ position: "relative", width: "fit-content" }}
      >
        <DialogTitle>Skapa en ny annons</DialogTitle>

        <DialogContent>
          <Stack spacing={2}>
            <Typography color="text.secondary" maxWidth={380} variant="body2">
              {userAction}. Om du redigerar annonsen kommer en ny version att
              skapas. Du kommer fortfarande ha tillgång till din tidigare
              version.
            </Typography>
            <Typography color="text.secondary" maxWidth={380} variant="body2">
              Du måste skicka in din nya annons till tidningen innan tidningens
              stopptid annars kommer din föregående annons att publiceras.
            </Typography>
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>Avbryt</Button>
          <Button onClick={onSubmit}>Redigera</Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default memo(EditNonPublishableAdDialog);
